import _ from 'underscore';

var initializeGTM = _.once(function () {});

export default (function () {

    return function () {
        initializeGTM();
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/googleTagManager.js
// module id = 912
// module chunks = 0